// (function () {
//   const ENABLED = true;
//   const UPSELL_VARIANT_ID = 43929068208179;

//   if (!ENABLED) return;

//   let isProcessing = false;

//   document.addEventListener(
//     'submit',
//     function (e) {
//       const form = e.target;

//       if (!form.matches('form[action*="/cart/add"]')) return;

//       // prevent double trigger
//       if (isProcessing) return;
//       isProcessing = true;

//       // fully stop theme submission
//       e.preventDefault();
//       e.stopImmediatePropagation();

//       const formData = new FormData(form);
//       const mainVariantId = formData.get('id');
//       const quantity = Number(formData.get('quantity')) || 1;

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json'
//         },
//         body: JSON.stringify({
//           items: [
//             {
//               id: mainVariantId,
//               quantity: quantity
//             },
//             {
//               id: UPSELL_VARIANT_ID,
//               quantity: 1
//             }
//           ]
//         })
//       })
//         .then((res) => res.json())
//         .then(() => {
//           // simple fallback (stable)
//          document.dispatchEvent(new CustomEvent('cart:refresh'));
//         })
//         .catch((err) => {
//           console.error(err);
//           isProcessing = false;
//         });
//     },
//     true // capture mode
//   );
// })();



document.addEventListener("DOMContentLoaded", function () {

  const customerMakeMap = {
  "wholesale-alfaromeo": "AlfaRomeo",
  "wholesale-audi": "Audi",
  "wholesale-bmw": "BMW",
  "wholesale-byd": "BYD",
  "wholesale-bentley": "Bentley",
  "wholesale-chery": "Chery",
  "wholesale-chevy": "Chevy",
  "wholesale-cupra": "Cupra",
  "wholesale-fiat": "Fiat",
  "wholesale-ford": "Ford",
  "wholesale-gwm": "GWM",
  "wholesale-genesis": "Genesis",
  "wholesale-honda": "Honda",
  "wholesale-hyundai": "Hyundai",
  "wholesale-ineos": "Ineos",
  "wholesale-isuzu": "Isuzu",
  "wholesale-jaecoo": "Jaecoo",
  "wholesale-jeep": "Jeep",
  "wholesale-kia": "Kia",
  "wholesale-landrover": "Landrover",
  "wholesale-lexus": "Lexus",
  "wholesale-mg": "MG",
  "wholesale-mini": "MINI",
  "wholesale-mazda": "Mazda",
  "wholesale-mercedes": "Mercedes",
  "wholesale-mitsubishi": "Mitsubishi",
  "wholesale-nissan": "Nissan",
  "wholesale-porsche": "Porsche",
  "wholesale-ram": "Ram",
  "wholesale-rangerover": "RangeRover",
  "wholesale-skoda": "Skoda",
  "wholesale-subaru": "Subaru",
  "wholesale-suzuki": "Suzuki",
  "wholesale-tesla": "Tesla",
  "wholesale-toyota": "Toyota",
  "wholesale-volkswagen": "Volkswagen",
  "wholesale-volvo": "Volvo"
};

  let customerTags = [];

  try {

    const tags = window.BSS_Login_Analytics?.customer?.tags;

    if (typeof tags === 'string') {
      customerTags = tags.split(',').map(t => t.trim().toLowerCase());
    } else if (Array.isArray(tags)) {
      customerTags = tags.map(t => String(t).toLowerCase());
    }

  } catch (e) {}

  let allowedMake = null;

  customerTags.forEach(tag => {

    if (customerMakeMap[tag]) {
      allowedMake = customerMakeMap[tag];
    }

  });

  // RETAIL CUSTOMER
  if (!allowedMake) return;

  // FORCE URL PARAM
  const currentUrl = new URL(window.location.href);

  if (currentUrl.searchParams.get('gff_303224') !== allowedMake) {

    currentUrl.searchParams.set('gff_303224', allowedMake);

    window.location.replace(currentUrl.toString());

    return;
  }

  // KEEP DISABLED
  const interval = setInterval(() => {

    const makeSelect = document.querySelector('#gff_303224');

    if (!makeSelect) return;

    // ALWAYS FORCE VALUE
    makeSelect.value = allowedMake;

    // ALWAYS DISABLE
    makeSelect.disabled = true;
    makeSelect.setAttribute('disabled', 'disabled');

    // HARD BLOCK
    makeSelect.style.pointerEvents = 'none';
    makeSelect.style.background = '#f5f5f5';
    makeSelect.style.cursor = 'not-allowed';
    makeSelect.style.opacity = '1';

    makeSelect.onmousedown = function(e) {
      e.preventDefault();
      return false;
    };

    makeSelect.onclick = function(e) {
      e.preventDefault();
      return false;
    };

  }, 500);

});


// Shop Now CTA – Vehicle Selector Scroll/Modal UX

// document.addEventListener('click', function(e) {
//   const link = e.target.closest('a[href="#shop-now"]');

//   if (!link) return;

//   e.preventDefault();

//   document.querySelector('#gf-form')?.scrollIntoView({
//     behavior: 'smooth',
//     block: 'center'
//   });
// });